import React, { Component } from "react";
import { alertActions } from '../../action/AlertAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { accountActions } from '../../action/AccountAction';
import CryptoJS from 'crypto-js';
import { loginActions } from '../../action/loginAction';
import { history } from '../../helpers/history';
import { commonClass } from "../../helpers/commonClass";
import { Helmet } from "react-helmet";
import TooltipNotes from "../../Tooltip/Tooltip";
import BonusDetailspopup from '../../bonuspopup';
import ViewAvailBonus from "./ViewAvailBonus";

let deviceId = "~1"; //1- for web , 2-for-mobileapp 3 - for mobileWeb
let payType = "~1"; //1- for wallet, 2-buy

let myifrmInter = null;
let myifrmHeight = 0;
function receiveMessage(e) {
    if (e.data && e.data.msgtype == 'ifrmh') {
        myifrmHeight = e.data.data;
    }
}
window.addEventListener('message', receiveMessage);


class Wallet extends Component {
    constructor(props) {
        super(props);
        this.iframwrefs = React.createRef();
        let CurrencyObj1 = localStorage.getItem("setuserCurrencynew");
        let CurrencyObj = CurrencyObj1 ? JSON.parse(CurrencyObj1) : { code: process.env.REACT_APP_CURRENCY_NAME };
        //let lreqdata = CryptoJS.AES.encrypt(this.props.user.mobileNo + "~" + this.props.user.loginKey + "~" + this.props.user.Country_code.replaceAll("+", "") + "~" + this.props.user.balance + "~0~" + this.props.i18n.language + deviceId + payType + "~0" + "~" + process.env.REACT_APP_DESKTOP_URL + `/${window.location.pathname.split('/')[1]}` + "~0~" + CurrencyObj.code + "~" + this.props.user.Player_name + "~" + this.props.user.emailID + "~" + "0", "U2FsdGVkX1/dTA00hg0swnksKTyUdhPWxhPpY1CEqEs=");
        let urlpath = window.location.pathname.split('/')[window.location.pathname.split('/').length - 1].toLowerCase()
        let lreqdata = CryptoJS.AES.encrypt(this.props.user.mobileNo + "~" + this.props.user.loginKey + "~" + this.props.user.Country_code.replaceAll("+", "") + "~" + this.props.user.balance + "~0~" + this.props.i18n.language + deviceId + payType + "~0" + "~" + process.env.REACT_APP_DESKTOP_URL + `/${urlpath}` + "~0~" + CurrencyObj.code + "~" + this.props.user.Player_name + "~" + this.props.user.emailID + "~" + "0", "U2FsdGVkX1/dTA00hg0swnksKTyUdhPWxhPpY1CEqEs=");
        this.state = {
            redirecturl: process.env.REACT_APP_WALLET_URL + 'home?data=' + lreqdata.toString().replaceAll("+", "@"),
            balWait: false,
            cbal: this.props.user.balance,
            setEvnt: false,
            showloader: true,
            CurrencyName: CurrencyObj,
            bonuspopup: false,
            SelectBonusObj: {},
            RenderFlag: true
        }
        this.props.getBalance(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey, this.props.user.Country_code);
    }
    getbal = () => {
        //due to payment popup oepn in same tab ,so the page laaded again so,bal call at constrator
        //this.props.getBalance(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey, this.props.user.Country_code);
        this.state.balWait = true;
        this.state.cbal = this.props.user.balance;
        let gotcartflog = localStorage.getItem('isRedirectToCart');
        if (gotcartflog == 1) {
            localStorage.removeItem('isRedirectToCart');
            setTimeout(() => {
                history.push('/payment');
            }, 500);
        }
        else {
            this.resetPGURL(); //reload if user close the pg page manually
        }
    }


    CloseImage = () => {
        this.setState({ bonuspopup: !this.state.bonuspopup })
    }


    bonusdetailscontrol = () => {
        this.setState({ bonuspopup: !this.state.bonuspopup })
        setTimeout(() => { window.HomePageOfferimg() }, 1000)//700
    }


    GetSelectBonus = (Obj) => {
        this.setState({ SelectBonusObj: Obj })
        this.resetPGURL(Obj.bonus_id)
    }
    componentDidUpdate(prevProps) {
        if (this.props.user && (this.state.cbal != this.props.user.balance || this.state.balWait)) {
            this.state.cbal = this.props.user.balance;
            this.state.balWait = false;
            // let lreqdata = CryptoJS.AES.encrypt(this.props.user.mobileNo + "~" + this.props.user.loginKey + "~" + this.props.user.Country_code.replaceAll("+", "") + "~" + this.props.user.balance + "~0~" + this.props.i18n.language + deviceId + payType, "U2FsdGVkX1/dTA00hg0swnksKTyUdhPWxhPpY1CEqEs=");
            // let urlNew = process.env.REACT_APP_WALLET_URL + lreqdata.toString().replaceAll("+", "@");
            // this.setState({ redirecturl: urlNew });
            this.resetPGURL();
        }
        this.onLoadMyVirtual();
    }
    resetPGURL = (bonus_cate_id) => {
        let bonus_id = bonus_cate_id ? bonus_cate_id : '0'
        let lreqdata = CryptoJS.AES.encrypt(this.props.user.mobileNo + "~" + this.props.user.loginKey + "~" + this.props.user.Country_code.replaceAll("+", "") + "~" + this.props.user.balance + "~0~" + this.props.i18n.language + deviceId + payType + "~0" + "~" + process.env.REACT_APP_DESKTOP_URL + `/${window.location.pathname.split('/')[1]}` + "~0~" + this.state.CurrencyName.code + "~" + this.props.user.Player_name + "~" + this.props.user.emailID + "~" + bonus_id, "U2FsdGVkX1/dTA00hg0swnksKTyUdhPWxhPpY1CEqEs=");
        let urlNew = process.env.REACT_APP_WALLET_URL + 'home?data=' + lreqdata.toString().replaceAll("+", "@");
        this.setState({ redirecturl: urlNew });
    }
    componentDidMount() {
        if (this.props.locationData) {
            const query = new URLSearchParams(this.props.locationData.search);
            const token = query && query.get('pn')
            if (token) {
                const token1 = CryptoJS.AES.decrypt(token.replaceAll("@", "+").replaceAll(" ", "+"), "U2FsdGVkX1/dTA00hg0swnksKTyUdhPWxhPpY1CEqEs=").toString(CryptoJS.enc.Utf8);
                const ft = token1.split("~");
                if (ft && ft.length > 1) {
                    this.getbal();
                }
            }
        }
        //due to payment popup oepn in same tab
        //window.updateMyBalance(this.getbal);
        //window.addEventListener('message', window.receiveMessage, false);

        //// localStorage.setItem('atabId', 3); this code is using in Account Component
        this.onLoadMyVirtual();
    }
    showMsg = (Msg) => { this.props.alertError(Msg); }

    onLoadMyVirtual = () => {
        if (this.iframwrefs.current && this.state.setEvnt != true) {
            this.state.setEvnt = true;
            var iframe = this.iframwrefs.current;
            if (this.props.user.mobileNo != 0) { // only for logged in players
                let mythis = this;
                if (iframe.attachEvent) { // for IE
                    iframe.attachEvent("onload", function () {
                        console.log("iframe.attachEvent")
                        mythis.setState({ showloader: false });
                    });
                }
                else { // for Non IE
                    iframe.onload = function () {
                        console.log("iframe.onload")
                        mythis.setState({ showloader: false });
                    };
                }
            }
            let mythis1 = this;
            let tmr1 = setTimeout(
                () => {
                    if (mythis1.state.showloader) { mythis1.setState({ showloader: false }); }
                    clearTimeout(tmr1);
                }
                , 4000)
        }
    }


    myifrmload = () => {
        let iframe = this.iframwrefs;
        if (iframe && iframe.current && myifrmInter == null) {
            myifrmInter = setInterval(() => {
                if (myifrmHeight != 0) {
                    clearInterval(myifrmInter);
                    if (iframe.current) {
                        //iframe.height = iframe.current.contentWindow.document.body.scrollHeight + "px";                       
                        iframe.current.height = myifrmHeight + "px";
                    }
                }
            }, 200);
        }
    }

    ChangeComponent = (flag) => {
        this.setState({ RenderFlag: flag })
    }

    render() {
        const { t } = this.props;
        return (

            <>
                {
                    process.env.REACT_APP_MODE != "development" && <Helmet>
                        <title>Gulf Ticket : Wallet</title>
                        <meta name="description" content="Gulf Ticket Wallet" />
                    </Helmet>
                }
                {this.state.RenderFlag == true ?
                    <div class="myAccCont">
                        <div class="myAccContHead">
                            <h1><img src="./assets/img/icons/tabs-wallet.png" />Add Credit</h1>
                            <div class="proChangePass" onClick={() => { this.props.changeFlag(1) }}><a > {t('lblBack')} </a></div>
                        </div>
                        <>
                            <div class="creditselPayment">
                                <div class="selPayment">
                                    <div class="selPaymentCont">
                                        <div class="selPaymentContLi">
                                            <div class="add-cerdit">
                                                <div class="credit-header">
                                                    <h3><img src="./assets/img/icons/Prizes-2.png" />Wallet Balance</h3>
                                                </div>
                                                <div class="amountcredit">{this.props.appvariables.currency}  {this.props.user.balance}</div>
                                                <button class="add-credit-btn2" onClick={() => { this.ChangeComponent(false) }} >View Available Bonus</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="transaction">
                                {/* <h1 className="walletubalde" onClick={() => { this.props.changeFlag(4) }} ><a className="viewbonus">{t('lblview')} {t('lblavailbonus')}</a> </h1> */}
                                {Object.keys(this.state.SelectBonusObj).length > 0 && <label style={{ marginTop: "10px", textAlign: "center", color: "#c37305" }}>{t('lblappliedbonus')} : {this.state.SelectBonusObj.bonus_name}</label>}
                                <iframe id="wallet_iframe" onLoad={this.myifrmload} ref={this.iframwrefs} src={this.state.redirecturl} width="100%" height="550" style={{ "border": "none" }}></iframe>
                            </div>
                        </>
                    </div>
                    :
                    <ViewAvailBonus getbonus={(value) => { this.GetSelectBonus(value) }} filtertype={2} ChangeComponent={(flag) => { this.ChangeComponent(flag) }} changeFlag={this.props.changeFlag} />}





                {/* {this.state.bonuspopup && <>
                    <div className="lightboxinfo3">
                        <a className="lightBoxClose" onClick={() => { this.CloseImage() }}><img src="./assets/img/icons/cloes-icon.png?v0.1" /></a>
                        <div className="lightBox-wrap">
                            <div class="mainContainer" >
                                <div className='wrap2' style={{ backgroundColor: "white" }}>
                                    <BonusDetailspopup filtertype={2} getbonus={(value) => { this.GetSelectBonus(value) }} ClosePopup={() => { this.CloseImage() }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div onClick={() => { this.CloseImage() }} className="overlay"></div>
                </>} */}
            </>

        );
    }
}
function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    const { Amtrestnotes } = state.gameReducer;
    return { user, appvariables, Amtrestnotes };
}
const mapActionToProps = {
    alertError: alertActions.error,
    Cashdesposite: accountActions.Cashdesposite,
    getBalance: loginActions.getBalance,
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(Wallet))